export const phrases = {
  errorMessagesComponentsFriendlyMessage: {
    key: 'error-messages-components-001',
    default: 'Door een technische storing kan dit paginaonderdeel niet worden weergegeven'
  }
}
